import { ACCEPTED_FILE_TYPES } from './schema'
import { ACCEPTED_FILE_TYPES_TWO } from './uploadSchema'
export const ContactInformation = [
  {
    name: 'startup_name',
    label: 'Startup/Company name',
    type: 'text',
    required: true,
    disabled: false,
  },

  {
    name: 'legal_entity_type' as const,
    label: 'Legal entity type',
    type: 'custom_select' as const,
    placeholder: 'Select Legal Entity Type',
    required: true,
    disabled: false,
    desc: 'name',
    descId: 'id',
    id: 'legal_entity_type',
    data: [
      { name: 'Sole Proprietorship', id: '1' },
      { name: 'Partnership', id: '2' },
      { name: 'Private Limited Company', id: '3' },
      { name: 'LLP', id: '4' },
    ],
  },
  {
    name: 'registration_date',
    label: 'Date of registration/incorporation',
    type: 'date',
    required: true,
    disabled: false,
  },
  { name: 'website', label: 'Website', type: 'text', disabled: false },
]
export const personalInformation = [
  {
    name: 'contact_name',
    label: 'Full name',
    type: 'text',
    required: true,
    disabled: false,
  },
  {
    name: 'contact_designation',
    label: 'Designation',
    type: 'text',
    required: true,
    disabled: false,
  },
  {
    name: 'contact_email',
    label: 'Email address',
    type: 'email',
    required: true,
    disabled: false,
  },
  {
    name: 'contact_phone',
    label: 'Phone number',
    type: 'text',
    required: true,
    disabled: false,
  },
]

export const addressInformation = [
  {
    name: 'address_street',
    label: 'Street address',
    type: 'textarea',
    required: true,
    disabled: false,
  },
  {
    name: 'address_city',
    label: 'City',
    type: 'text',
    required: true,
    disabled: false,
  },
  {
    name: 'address_state',
    label: 'State/Province',
    type: 'text',
    required: true,
    disabled: false,
  },
  {
    name: 'address_zip',
    label: 'PIN/Zip Code',
    type: 'text',
    required: true,
    disabled: false,
  },
  {
    name: 'address_country',
    label: 'Country',
    type: 'text',
    required: true,
    defaultValue: 'India',
    disabled: false,
  },
]

export const aboutStartup = [
  {
    name: 'industry_sector' as const,
    label: 'Sector/Industry',
    type: 'custom_select' as const,
    placeholder: 'Select Sector/Industry',
    required: true,
    disabled: false,
    desc: 'name',
    descId: 'id',
    id: 'industry_sector',
    data: [
      { name: 'Technology', id: '1' },
      { name: 'Healthcare', id: '2' },
      { name: 'Education', id: '3' },
      { name: 'E-commerce', id: '4' },
      { name: 'Agri-tech', id: '5' },
      { name: 'Fintech', id: '6' },
    ],
  },

  {
    name: 'startup_stage',
    label: 'Startup Stage',
    type: 'text',
    required: true,
    disabled: false,
  },

  {
    name: 'business_description',
    label: 'Brief Description of your Startup/Business Idea',
    type: 'textarea',
    required: true,
    disabled: false,
  },
]

export const incubationNeeds = [
  {
    name: 'annual_turnover',
    label: 'Annual Turnover',
    type: 'text',
    required: true,
    disabled: false,
  },
  {
    name: 'problem_statement',
    label: 'Preferred Incubation Duration',
    type: 'text',
    required: true,
    disabled: false,
  },
  {
    name: 'additional_comments',
    label: 'Any Additional Comments',
    type: 'text',
    required: false,
    disabled: false,
  },
  {
    name: 'solution',
    label: 'solution',
    type: 'text',
    required: false,
    disabled: false,
  },
  {
    name: 'unique_value_proposition',
    label: 'Unique Value Proposition',
    type: 'text',
    required: false,
    disabled: false,
  },
  {
    name: 'target_market',
    label: 'Target Market',
    type: 'text',
    required: false,
    disabled: false,
  },
  {
    name: 'revenue_model',
    label: 'Revenue Model',
    type: 'text',
    required: false,
    disabled: false,
  },
  {
    name: 'service_interest',
    label: 'Service Interest',
    type: 'text',
    required: false,
    disabled: false,
  },

  {
    name: 'previous_programs',
    label: 'Previous Programs',
    type: 'text',
    required: false,
    disabled: false,
  },
  {
    name: 'declaration_agreed',
    label: 'Declaration',
    type: 'radio',
    required: true,
    data: [
      { id: 1, radioLabel: 'Yes', value: 'true' },
      { id: 2, radioLabel: 'No', value: 'false' },
    ],
    disabled: false,
  },

  {
    name: 'declaration_date',
    label: 'Declaration Date',
    type: 'date',
    required: false,
    disabled: false,
  },

  {
    name: 'signature',
    required: false,
    id: 'attachment',
    selectedFiles: [],
    descId: 'id',
    supportedExtensions: ACCEPTED_FILE_TYPES,
    supportedFiles: ACCEPTED_FILE_TYPES,
    acceptedFiles: 'upload .jpeg, .jpg, .png files',
    type: 'file_upload',
    value: null,
    needConfirmation: true,
    disabled: false,
  },
]

export const uploadCv = [
  {
    name: 'pitch_deck_user',
    required: false,
    id: 'attachment',
    selectedFiles: [],
    descId: 'id',
    supportedExtensions: ACCEPTED_FILE_TYPES_TWO,
    supportedFiles: ACCEPTED_FILE_TYPES_TWO,
    acceptedFiles: 'upload .jpeg, .jpg, .png, .pdf files',
    type: 'file_upload',
    value: null,
    needConfirmation: true,
    disabled: false,
  },
]
